import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.396 16.384l-7.526 -13.877a1 1 0 0 0 -1.74 0l-1.626 2.998m-1.407 2.594l-5.097 9.398v.5c0 1.66 4.03 3.003 9 3.003c3.202 0 6.014 -.558 7.609 -1.398","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconConeOff = createReactComponent('outline', 'cone-off', 'ConeOff', __iconNode);

export default IconConeOff;